<template>
  <v-row no-gutters align="center" class="py-0 py-md-4">
    <v-col class="d-flex flex-column">
      <div class="text-h3" v-html="$t('prevention.personalization.title')" />
      <div
        class="text-body-small grey-darken-1--text"
        v-html="$t('prevention.personalization.text')"
      />
    </v-col>
    <v-col class="flex-shrink-1 flex-grow-0 ml-4">
      <v-switch
        v-model="personalizationEnabled"
        hide-details
        inset
        color="success"
        @click="sendGtmEvent('Personalizace prevence')"
      />
    </v-col>
  </v-row>
</template>

<script>
import userAppData from '@/mixins/userAppData';
import preventionData from '@/mixins/preventionData';
import formGtm from '@/mixins/formGtm';

export default {
  name: 'PreventionPersonalization',
  mixins: [userAppData, preventionData, formGtm],
  data() {
    return {
      parameterName: 'preventionPersonalizationEnabled'
    };
  },
  computed: {
    personalizationEnabled: {
      get() {
        const personalizationEnabledSettings = this.userAppData.find(
          val => val.name === this.parameterName
        );
        return personalizationEnabledSettings
          ? personalizationEnabledSettings.value === 'true'
          : true;
      },
      set(value) {
        this.$store.dispatch('profile/userAppData/updateLocaleUserAppData', {
          name: this.parameterName,
          value: value.toString()
        });
      }
    }
  },
  watch: {
    personalizationEnabled(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateUserAppData({
          name: this.parameterName,
          value: newValue
        });
        this.getPreventionData();
      }
    }
  }
};
</script>
